<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Vorname'"
      [name]="'firstName'"
      [colSize]="6">
      <input
        pInputText
        id="firstName"
        type="text"
        formControlName="firstName"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Nachname'"
      [name]="'lastName'"
      [colSize]="6">
      <input
        pInputText
        id="lastName"
        type="text"
        formControlName="lastName"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'E-Mail'" [name]="'email'" [colSize]="6">
      <input
        pInputText
        id="email"
        type="text"
        formControlName="email"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Anmeldename'"
      [name]="'username'"
      [colSize]="6">
      <input
        pInputText
        id="username"
        type="text"
        formControlName="username"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Telefon'" [name]="'phone'" [colSize]="6">
      <input
        pInputText
        id="phone"
        type="text"
        formControlName="phone"
        class="p-input" />
    </app-form-field-wrapper>
  </div>
  <p-divider />
  <div class="grid">
    <app-form-field-wrapper
      [colSize]="6"
      label="Rechte"
      [name]="'locked'"
      [floatingLabel]="true">
      <p-dropdown
        id="level"
        optionValue="value"
        [options]="userLevelOptions"
        formControlName="level">
        <ng-template pTemplate="selectedItem" let-item>
          <app-dropdown-option [item]="item" />
        </ng-template>
        <ng-template pTemplate="item" let-item>
          <app-dropdown-option [item]="item" />
        </ng-template>
      </p-dropdown>
    </app-form-field-wrapper>
  </div>
  <p-divider />
  <div class="grid">
    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Nutzer:in freigegeben?'"
      [name]="'locked'"
      [floatingLabel]="false">
      <p-inputSwitch
        id="locked"
        [falseValue]="true"
        [trueValue]="false"
        formControlName="locked"></p-inputSwitch>
    </app-form-field-wrapper>

    @if (form.value['level'] === 0) {
      <app-form-field-wrapper
        [colSize]="6"
        [label]="'Administrator:in?'"
        [name]="'isAdmin'"
        [floatingLabel]="false">
        <p-inputSwitch
          id="isAdmin"
          [falseValue]="false"
          [trueValue]="0"
          formControlName="isAdmin"></p-inputSwitch>
      </app-form-field-wrapper>
    }
  </div>

  @if (form.value['level'] === 0) {
    @if (form.value['isAdmin']) {
      <app-alert [canToggle]="false" styleClass="p-3">
        <b>Administratoren</b> steht der komplette Atlas zur Verfügung. Jegliche
        Rollen- und Arbeitsbereich-Einstellungen werden ignoriert!
      </app-alert>
    }

    @if (!communeFromRoute) {
      <p-divider></p-divider>
      <app-header
        suffix="beta"
        suffixIcon="fas fa-flask"
        icon="fas fa-users-viewfinder"
        text="Arbeitsbereiche und Rechte"></app-header>
      <div formArrayName="workspaces" class="grid">
        <ng-container
          *ngFor="
            let workspaceControl of workspacesFormArray.controls;
            let i = index
          "
          [formGroupName]="i">
          <app-form-field-wrapper
            [label]="'Arbeitsbereich'"
            [name]="'workspace'"
            [colSize]="4">
            <p-dropdown
              *ngIf="workspaceStore.asArray() as workspaces"
              [options]="workspaces"
              optionLabel="name"
              optionValue="_id"
              dataKey="_id"
              formControlName="workspace">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <i
                    [class]="
                      workspaceTypeIconMap[
                        asWorkspaceTypeKey(selectedOption.type)
                      ]
                    "></i>
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <i
                    [class]="
                      workspaceTypeIconMap[asWorkspaceTypeKey(item.type)]
                    "></i>
                  <div>{{ item.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </app-form-field-wrapper>

          <app-form-field-wrapper
            [label]="'Rollen'"
            [name]="'roles'"
            [colSize]="6">
            <p-multiSelect
              *ngIf="roleStore.asArray() as roles"
              [options]="roles"
              optionLabel="name"
              optionValue="_id"
              dataKey="_id"
              formControlName="roles"></p-multiSelect>
          </app-form-field-wrapper>

          <app-form-field-wrapper [hideLabel]="true" [colSize]="1">
            <p-button
              (click)="removeWorkspace(i)"
              icon="fas fa-trash"
              [severity]="'danger'"
              [size]="'small'"
              [rounded]="true"></p-button>
          </app-form-field-wrapper>
        </ng-container>
      </div>

      <div
        *ngIf="!form.value['workspaces'].length"
        role="alert"
        class="p-message p-message-info">
        <div class="p-message-wrapper">
          <span class="p-message-summary"
            >Keine Arbeitsbereiche zugewiesen</span
          >
          <span class="p-message-detail"
            >Nutzer:in hat Zugriff auf alle Daten</span
          >
        </div>
      </div>

      <p-divider></p-divider>
      <button
        pButton
        icon="fas fa-circle-plus"
        label="Arbeitsbereich hinzufügen"
        class="p-button-rounded p-button-success w-auto"
        (click)="addWorkspace()"></button>

      <p-divider></p-divider>

      <h3>Tool-Zugriff</h3>
      <div formGroupName="toolAccess">
        <div *ngFor="let access of toolAccess" class="field-checkbox">
          <p-checkbox
            [binary]="true"
            [label]="access.name"
            name="accessList"
            [checkboxIcon]="access.icon"
            [formControlName]="access.key"></p-checkbox>
        </div>
      </div>

      <p-divider></p-divider>

      <h3>Bereiche</h3>
      <div formGroupName="viewAccess">
        <div *ngFor="let access of viewAccess" class="field-checkbox">
          <p-checkbox
            [binary]="true"
            [label]="access.name"
            [checkboxIcon]="access.icon"
            name="accessList"
            [formControlName]="access.key"></p-checkbox>
        </div>
      </div>
    }
  }

  <p-divider></p-divider>
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="!!itemToEdit"
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit
        ? confirm(undefined, itemToEdit, itemToEdit.username)
        : undefined
    "></app-form-footer>
</form>
